//
// Composant qui fait une sortie : le rond et le triangle
//

<template>
<div>
        <v-circle
                :config="{
                                x: res.x,
                                y: res.y,
                                radius: 20,
                                fill: 'black',
                                stroke: 'black',
                                strokeWidth: 5,
                                visible:show,
                                listening:false,
                                }">
        </v-circle>
        <v-text :config="{
                                 x: res.x-25,
                                y: res.y+30,
                          width:50,
                          fill: 'black',
                          text: theCaracValue,
                          fontSize:18,
                          fontStyle:'bold',
                          align:'center',
                          visible:show,
                          listening:false,
                          }"></v-text>

        <v-image v-if="nothingIsMoving"
                @click="confirmDelete"
                 :config="{
                                  x : res.x-8,
                                  y: res.y-36,
                                  image:imgClose,
                                  }"></v-image>


        <v-circle  ref="resultat"
                   name="resultat"
                     @dragstart="linkSortieDragStart"
                     @dragmove="linkSortieDragMove"
                     @dragend="linkSortieDragStop"
                     @mouseenter="cursorMove"
                     @mouseleave="cursorDefault"
                     @click="editResultat"
                   :config="{
                                x: res.x,
                                y: res.y,
                                srcX : res.x,
                                srcY: res.y,
                                groupRef: res.from,
                                radius: 15,
                                fill: res.data.color,
                                stroke: '#606266',
                                strokeWidth: selectionned,
                                draggable: imAlive,
                                type:res.type,
                                }">
        </v-circle>

</div>
</template>

<script>

    import Lien from '../classes/Lien'


    export default {
        components:{

        },
    data(){
        return{
                selectionned:2,

                imgClose:null,

                theCaracValue:'',
        }
    },
        props:[ 'res' ],
        computed:{
            getScale () {
                return this.$store.getters.getScale;
            },
            imAlive(){
                   let alive=true
                   if(this.res.data.reload===1){
                           this.$emit('reloadRes',this.res.data)
                           alive=false
                   }
                    return alive
            },
            show(){
               const tmp=this.$store.getters.isSomeThingToShow;
               if(this.res.data.condition.indexOf(tmp)>=0 || this.res.data.consequence.indexOf(tmp)>=0 || this.res.data.meta.indexOf(tmp)>=0){
                       this.getDBCaracValue(tmp)
                       return true
               }
               else
                       return false
            },

        //Flag : On dessine que si rien ne bouge
            nothingIsMoving(){
                        return !this.$store.getters.isSomeThingMoving
                },



        },
        methods: {

                async getDBCaracValue(tmp)
                {
                        const res=await this.$mydb.do.getCaracAllType(this.res.id, tmp)
                        this.theCaracValue=res[0].valeur
                },

                storeGetLinkFromTo(from,to){
                        return this.$store.getters.storeGetLinkFromTo(from,to)
                },
                storeGetLinkFromToInverse(from,to){
                        return this.$store.getters.storeGetLinkFromToInverse(from,to)
                },

            //********************************************************
            // EVENEMENT DU DRAG POUR FAIRE UN LIEN
            //********************************************************

            linkSortieDragStart(evt){

                const mySrc = evt.target;
                const theStage = mySrc.getStage();
                const pos = theStage.getPointerPosition();

                pos.x=(pos.x -theStage.x())/this.getScale
                pos.y=(pos.y -theStage.y())/this.getScale

                // Nouvelle ligne de lien en construction
                // oui.... elle est créée à la volée ...
                //console.log(pos.x+"/"+pos.y)
                this.redLine = new Konva.Line({
                    points: [(mySrc.x()+mySrc.parent.x()), (mySrc.y()+mySrc.parent.y()), pos.x,pos.y],
                    strokeWidth: 3,
                    stroke:this.res.data.color
                });



                mySrc.moveTo(theStage.find('.DragLayer')[0]);
                theStage.draw(); //Force un refresh du graph

                mySrc.getLayer().add(this.redLine)



            },

            linkSortieDragMove(evt){
                const mySrc = evt.target;
                const pos = mySrc.getStage().getPointerPosition();

                const theStage= mySrc.getStage()
                //mettre a jour uniquement la destination de la ligne
                const old=[...this.redLine.points()];

                const postmp={x:0,y:0}
                postmp.x=(pos.x -theStage.x())/this.getScale
                postmp.y=(pos.y -theStage.y())/this.getScale
                this.redLine.setAttrs(
                    {points:[old[0],old[1],postmp.x,postmp.y]}
                )


                //********************************************
                //Detection d'intersection Resultats/Requis
                //********************************************

                const inter=mySrc.getStage().getIntersection(pos);


                // ENTER ZONE
                if(inter && (inter.attrs.name==='Requis') )
                {

                    inter.fire(
                        'dragenter',
                        {
                            type: 'dragenter',
                            target: inter,
                            evt: evt.evt
                        },
                        true
                    )
                    this.lastCollision=inter;

                    if(inter.attrs.groupRef===mySrc.attrs.groupRef)
                        console.log("ben non !!... ;)")
                }

                // LEAVE ZONE
                if(!inter && this.lastCollision)
                {
                    this.lastCollision.fire(
                        'dragout',
                        {
                            type: 'dragout',
                            target:  this.lastCollision,
                            evt: evt.evt
                        },
                        true
                    )
                    this.lastCollision=undefined;
                }
            },

            //********************************************
            // Detection que le drop est dans la zone
            //*****************************************

            async linkSortieDragStop(evt){
                const mySrc = evt.target;

                const theStage = mySrc.getStage();
                mySrc.moveTo(theStage.find("."+this.res.from)[0]);
                theStage.draw(); //Force un refresh du graph

                // Destroy la ligne du drag + reset position
                this.redLine.destroy();
                mySrc.position({x:mySrc.attrs.srcX, y:mySrc.attrs.srcY});
                mySrc.getStage().draw();


                const pos = mySrc.getStage().getPointerPosition();
                const inter=mySrc.getStage().getIntersection(pos);


                if(inter && (inter.attrs.name==='Requis' || inter.attrs.name==='circle'))
                {
                   const src=inter.getStage().find("."+mySrc.attrs.groupRef)[0];
                   const dst=inter.getStage().find("."+inter.attrs.groupRef)[0];

                   //check des cas interdits
                   let check=await this.$mydb.do.linkExist(this.res.id,inter.attrs.groupRef)
                   if(src===dst){
                           this.alertCustomError("Il n'est pas possible de boucler sur soi-même !")
                   }
                   else if(check!==0)
                   {
                           this.alertCustomError("Ce lien existe déjà !..")
                   }
                   else {
                           const lien= new Lien( mySrc.attrs.groupRef,this.res.id,inter.attrs.groupRef)

                           lien.points=[src.x(),src.y(),dst.x(),dst.y()]
                           lien.data.color=this.res.data.color
                           lien.data.label=this.res.data.label

                           // //On regarde s'il existe deja des lien sur le meme emplacement pour decaler s'il le faut
                           // let check=this.storeGetLinkFromTo(mySrc.attrs.groupRef,inter.attrs.groupRef).length
                           // if(this.storeGetLinkFromToInverse(mySrc.attrs.groupRef,inter.attrs.groupRef).length>0)
                           //         check++
                           //
                           // lien.data.decale=check

                           this.createLink(lien);


                   }
                        //Redessine le rond
                        inter.attrs.radius=11;
                        inter.getStage().draw()


                    this.lastCollision=undefined;
                }

            },
            //****************************************************
            // Decoration
            //****************************************************

            cursorMove(evt) {
                evt.target.getStage().container().style.cursor = 'move';
                evt.target.attrs.strokeWidth+=2;
                evt.target.getStage().draw();
            },
            cursorDefault(evt) {
                evt.target.getStage().container().style.cursor = 'default';
                evt.target.attrs.strokeWidth-=2;
                evt.target.getStage().draw();
            },

            editResultat(){
                const toEdit={
                        name:'TabResultat',
                        config:this.res
                };
                this.$store.commit('DROITE_SET',toEdit);
             },

             async deleteResultat(){
                try {

                        //del dans la base
                        await this.$mydb.do.deleteResultat(this.res);

                        //del des liens dans le store
                        this.$store.commit('DELETE_RESULTAT',this.res.id);

                        //Attention : tordu : Il faut que Tache.vue recharge les data de la base, donc il faut lui faire emettre un evenement
                        this.res.data.reload=1

                        //switch sidebar
                        const toEdit={
                                name:'TabHelp',
                                config:''
                        }
                        this.$store.commit('DROITE_SET',toEdit);
                }
                catch(e) {
                        console.log("Erreur:" + e)
                }
                },


                async createLink(value) {
                        await this.$mydb.do.createLink(value)
                        this.$store.commit('ADDLINK',value);
                        this.$emit('linkChange',value.to)

                },

                confirmDelete() {
                        this.$dialog.confirm({
                                title: 'Effacer cette sortie ?',
                                message: ' Cela effacera tous les liens qui en dépendent !',
                                confirmText: 'EFFACE',
                                cancelText: 'Annuler',
                                type: 'is-danger',
                                hasIcon: true,
                                onConfirm: () => this.deleteResultat()
                        })
                },

                //**********************************************************
                // DIFFERENTES ALERTES
                //**********************************************************
                alertCustomError(msg) {
                        this.$dialog.alert({
                                title: 'Error',
                                message: msg,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'alert-circle-outline',
                                iconPack: 'mdi'
                        })
                }

        },
        created() {
                    const image = new window.Image();
                    image.src = "close.png";
                    image.onload = () => {
                            // set image only when it is loaded
                            this.imgClose = image;
                    };
            },
        mounted (){
                this.$store.watch(
                        (state, getters) => getters.getDroite,
                        (newValue, oldValue) => {
                                if(newValue!=oldValue)
                                {
                                        if(newValue.config===this.res)
                                        {
                                                this.selectionned=10
                                        }
                                        else
                                        {
                                                this.selectionned=2
                                        }
                                }

                        },
                );

        }
    }


</script>


<style lang="scss">

</style>